/**
 * Created by DejanK on 1/11/2017.
 *
 * rbMin
 *
 * Validates that number is not less of given value
 */
export default rbMin;

function rbMin() {
  return {
    require: '?ngModel',
    link: (s, e, attrs, ngModelCtrl)=>{
      const min = parseFloat(attrs.rbMin);
      if(!isNaN(min)){
        if(ngModelCtrl){
          ngModelCtrl.$validators.rbMin = (modelValue, viewValue)=>{
            const v = parseFloat(modelValue || viewValue);
            return isNaN(v) || v >= min;
          }
        }
      } else {
        throw new Error(`RbMin requires a number but got ${attrs.rbMin}`);
      }
    }
  }
}
